import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import * as CCActions from './contract-class.actions';
import {
    ResponseStatus,
    IStatusMessage,
    DisplayMessageMinimum
} from '../../shared';
import * as fromShared from '../../shared';
import { ClassService } from '../class.service';

@Injectable()
export class ContractClassEffects {
    constructor(private actions$: Actions, private service: ClassService) {}

    postContractClass$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CCActions.postContractClass),
            switchMap(a =>
                this.service.postContractClass(a.ContractListID).pipe(
                    flatMap(resp => [
                        CCActions.loadContractClasses({
                            contractClasses: resp
                        }),
                        new fromShared.Errors.RemoveErrors(
                            resp
                                .filter(
                                    x =>
                                        x.Status.StatusCode ===
                                        ResponseStatus.Success
                                )
                                .map(x => x.ClassListID)
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        a =>
                                            a.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putContractClass$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CCActions.putContractClass),
            switchMap(a =>
                this.service.putContractClass(a.contractClasses).pipe(
                    flatMap(c => [
                        CCActions.updateContractClasses({
                            contractClasses: [
                                {
                                    id: a.contractClasses
                                        .map(x => x.ClassListID)
                                        .toString(),
                                    changes: c.Items[0]
                                }
                            ]
                        }),
                        new fromShared.Errors.RemoveErrors(
                            c.Items.filter(
                                x =>
                                    x.Status.StatusCode ===
                                    ResponseStatus.Success
                            ).map(x => x.ClassListID)
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...c.ErrorMessages.map(
                                    x =>
                                        ({
                                            StatusCode: -1,
                                            Message: x,
                                            MsgProcessID: 0,
                                            MsgEntityID: ''
                                        } as IStatusMessage)
                                ),
                                ...c.Items.filter(
                                    x =>
                                        x &&
                                        x.Status.StatusCode >=
                                            DisplayMessageMinimum
                                ).map(x => x.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
